import { NavigationInfoClosed } from "./NavigationInfoClosed";
import { NavigationInfoOpened } from "./NavigationInfoOpened";

export const NavigationInfo = ({ expanded }: any) => {
    return expanded ? <NavigationInfoOpened /> : <NavigationInfoClosed />;
};
